import { Kiosk } from '@gozoki/api-types';
import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { fetchCheckoutKiosks } from '../queries/checkoutKiosk.queries';

export const useCheckoutKiosks = (storeId: number): UseQueryResult<Kiosk[], unknown> => {
    return useQuery({
        queryKey: ['checkout', storeId],
        queryFn: () => {
            return fetchCheckoutKiosks(storeId);
        },
        refetchInterval: 5000,
        refetchOnWindowFocus: true,
        refetchOnReconnect: true,
    });
};
